import isString from 'lodash/isString'

/**
 * Just like the ThumbImage but uses hte size_1 named transformation
 * @param url
 */
export function toSize1Image(url: string) {
  if (!isString(url)) {
    return ''
  }

  //we use reg-ex to inject the transformation name on the URL
  // from https://res.cloudinary.com/tmmshauler/image/upload/v1680552378/panelpunches/MD-11301660R0150_3_nhwh2y.jpg to https://res.cloudinary.com/tmmshauler/image/upload/t_media_lib_thumb/v1680552378/panelpunches/MD-11301660R0150_3_nhwh2y.jpg
  // need to inject the "t_media_lib_thumb" after the "upload"
  return url.replace('https://res.cloudinary.com/tmmshauler/image/upload/', 'https://res.cloudinary.com/tmmshauler/image/upload/t_size_1/')
}
